import styled from 'styled-components';

import { EditOutlined, ArchiveOutlined } from '@mui/icons-material';

import colors from '../../../../../styles/colors';

const TagChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
`;

const MutedCell = styled.span`
  color: ${colors.shades.gamma7};
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledEditIcon = styled(EditOutlined)`
  font-size: 16px;
`;

const StyledArchiveIcon = styled(ArchiveOutlined)`
  font-size: 16px;
`;

export {
  TagChips,
  MutedCell,
  Actions,
  StyledEditIcon,
  StyledArchiveIcon,
};
